<template>
    <div>
        <hero-bar :has-right-visible="true" menu-icon="desktop-mac">
            {{ $lang.Menus.AllProjects }}

            <p v-if="backBtnActive == true" class="control" slot="right" style="margin-right: 16px">
                <b-button class="button is-gray" @click="previous">{{ $lang.Menus.BackBtn }}</b-button>
            </p>
        </hero-bar>

        <div class="section is-main-section table-page">
            <!-- The design's filter card: the range, then List and Download on one line. -->
            <div v-if="$store.state.memberId != 'TestMember' && $store.state.isAdmin == 1" class="filter-card">
                <p class="member-heading">{{ $lang.AdminExcel.Title_1 }}</p>
                <div class="filter-row">
                    <b-field :label="$lang.AdminExcel.FirstDate">
                        <b-datepicker v-model="firstDate"
                                      rounded
                                      icon="calendar-today"
                                      :icon-right="firstDate ? 'close-circle' : ''"
                                      icon-right-clickable
                                      @icon-right-click="clearDateTime_1"
                                      :locale="dateLocale"
                                      :date-formatter="formatPickerDate"
                                      :first-day-of-week="1">
                        </b-datepicker>
                    </b-field>
                    <b-field :label="$lang.AdminExcel.SecondDate">
                        <b-datepicker v-model="secondDate"
                                      rounded
                                      icon="calendar-today"
                                      :icon-right="secondDate ? 'close-circle' : ''"
                                      icon-right-clickable
                                      @icon-right-click="clearDateTime_2"
                                      :locale="dateLocale"
                                      :date-formatter="formatPickerDate"
                                      :first-day-of-week="1">
                        </b-datepicker>
                    </b-field>
                    <div class="filter-actions">
                        <b-button @click="getProjectsTable">{{ $lang.AdminExcel.ListProjects }}</b-button>
                        <b-button type="is-primary" icon-right="download" @click="downloadExcel">{{ $lang.AdminExcel.DownloadBtn }}</b-button>
                    </div>
                </div>
            </div>

            <!-- Widths: the five names share what is left; No, Boyut and Tarih are fixed. -->
            <b-table class="data-table is-sticky-lead"
                     style="--table-min: 900px"
                     :data="projectsdata"
                     :loading="isLoading"
                     :mobile-sort-placeholder="$lang.MyProjects.SortBy"
                     :paginated="isPaginated"
                     :per-page="perPage"
                     hoverable>
                <b-table-column field="UserName" :label="$lang.AdminExcel.UserName" v-slot="props" searchable>
                    {{ props.row.UserName }}
                </b-table-column>
                <b-table-column field="LastUserName" :label="$lang.ProjectInfos.LastUserName" v-slot="props" searchable>
                    {{ props.row.LastUserName }}
                </b-table-column>
                <b-table-column field="PanelManifacturer" :label="$lang.ProjectInfos.PanelManifacturer" v-slot="props" searchable>
                    {{ props.row.PanelManifacturer }}
                </b-table-column>
                <b-table-column field="ProjectName" :label="$lang.AdminExcel.ProjectName" v-slot="props" searchable cell-class="cell-strong m-title">
                    {{ props.row.ProjectName }}
                </b-table-column>
                <b-table-column field="PanelName" :label="$lang.AdminExcel.PanelName" v-slot="props" searchable cell-class="m-sub">
                    {{ props.row.PanelName }}
                </b-table-column>
                <b-table-column field="PanelNo" :label="$lang.AdminExcel.PanelNo" v-slot="props" width="96" searchable numeric>
                    {{ props.row.PanelNo }}
                </b-table-column>
                <b-table-column field="PanelDimension" :label="$lang.AdminExcel.PanelDimension" v-slot="props" width="136" searchable numeric>
                    {{ props.row.PanelDimension }}
                </b-table-column>
                <!-- ReportDate arrives as "MM/dd/yyyy HH:mm:ss"; shown dd-mm-yyyy, sorted as a date. -->
                <b-table-column field="ReportDate" :label="$lang.AdminExcel.Date" v-slot="props" width="120" searchable numeric sortable :custom-sort="sortByReportDate">
                    {{ formatReportDate(props.row.ReportDate) }}
                </b-table-column>

                <template #empty>
                    <!-- Rows loaded but none shown: the column search filtered them all out. -->
                    <p v-if="!isLoading" class="table-empty">{{ projectsdata.length ? $lang.AdminExcel.NoMatch : $lang.AdminExcel.EmptyRange }}</p>
                </template>

                <template #bottom-left>
                    {{ projectsdata.length }} {{ $lang.MyProjects.CountSuffix }}
                </template>
            </b-table>
        </div>
    </div>
</template>

<script>
    import router from '@/router';
    import api from '@/api';

    export default {
        name: 'AllProjects',
        data() {
            var prevDate = new Date();
            prevDate.setDate(prevDate.getDate() - 7);

            return {
                isActive: true,
                isLoading: false,
                firstDate: prevDate,
                secondDate: new Date(),
                showWeekNumber: false,
                enableSeconds: false,
                hourFormat: undefined, // Browser locale
                firstDayOfWeek: undefined, // 0 - Sunday
                isPaginated: true,
                perPage: 10,
                projectsdata: [],
                backBtnActive: false
            }
        },
        computed: {
            dateLocale() {
                return this.$lang.Format.Lang === 'tr-TR' ? 'tr-TR' : 'en-GB';
            }
        },
        mounted() {
            if (this.$store.state.previousRoute == 'projectInfos' || this.$store.state.previousRoute == 'panelInfos' || this.$store.state.previousRoute == 'envConditions' ||
                this.$store.state.previousRoute == 'calc_Busbar' || this.$store.state.previousRoute == 'calc_InputCircuit' || this.$store.state.previousRoute == 'calc_OutputCircuit' ||
                this.$store.state.previousRoute == 'calc_Manuel' || this.$store.state.previousRoute == 'calc_Summary' || this.$store.state.previousRoute == 'results' ||
                this.$store.state.previousRoute == 'reportPdfPage' || this.$store.state.previousRoute == 'calculation') {
                this.backBtnActive = true;
            } else {
                this.backBtnActive = false;
            }

            this.$store.state.isFooterFixed = true;
            this.getProjectsTable();
        },
        destroyed() {
            this.$store.state.isFooterFixed = false;
        },
        methods: {
            getProjectsTable() {
                this.isLoading = true;
                this.projectsdata = [];
                var first = this.formatDate(this.firstDate).toString();
                var second = this.formatDate(this.secondDate).toString();
                api.panels.getAllProjects(first, second).then((res) => {
                    // Cleared on both paths: on a failed call the full-page overlay used to
                    // stay up and lock the screen.
                    this.isLoading = false;
                    if (!res || res.isError) {
                        console.log("error ");
                    } else {
                        res.data.forEach((e) => {
                            this.projectsdata.push(e);
                        });
                    }
                });
            },

            clearDateTime_1() {
                this.firstDate = null
            },
            clearDateTime_2() {
                this.secondDate = null
            },
            formatDate(date) {
                const year = date.toLocaleString('default', { year: 'numeric' });
                const month = date.toLocaleString('default', {
                    month: '2-digit',
                });
                const day = date.toLocaleString('default', { day: '2-digit' });

                return [year, month, day].join('-');
            },

            downloadExcel() {
                this.isLoading = true;
                var first = this.formatDate(this.firstDate).toString();
                var second = this.formatDate(this.secondDate).toString();

                var s = 'GetProjects_Excel?First=' + first + '&Second=' + second + '&LangCode=' + this.$lang.Format.Lang;
                api.reportApi.getExcel_Projects('Panel', null, null, this.$lang.Menus.AllProjects, s).then((res) => {
                    this.isLoading = false;
                });
            },

            columnTdAttrs(row, column) {
                if (row.id === 'Total') {
                    if (column.label === 'ID') {
                        return {
                            colspan: 4,
                            class: 'has-text-weight-bold',
                            style: {
                                'text-align': 'left !important'
                            }
                        }
                    } else if (column.label === 'Gender') {
                        return {
                            class: 'has-text-weight-semibold'
                        }
                    } else {
                        return {
                            style: { display: 'none' }
                        }
                    }
                }
                return null
            },
            // GetAllProjects sends ReportDate as "MM/dd/yyyy HH:mm:ss", which as text sorts by
            // month and day with the years mixed; compare the dates themselves.
            sortByReportDate(a, b, isAsc) {
                const time = (row) => new Date(row.ReportDate).getTime() || 0;
                return isAsc ? time(a) - time(b) : time(b) - time(a);
            },
            // The pickers used the browser's format (9/16/2026); the tables show dd-mm-yyyy.
            formatPickerDate(date) {
                return ('0' + date.getDate()).slice(-2) + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + date.getFullYear();
            },
            previous() {
                router.push('/' + this.$store.state.previousRoute);
            },
            formatReportDate(dateString) {
                if (dateString == null) {
                    return '-';
                } else {
                    var date = new Date(dateString);

                    var yil = date.getFullYear();
                    var ay = ('0' + (date.getMonth() + 1)).slice(-2);
                    var gun = ('0' + date.getDate()).slice(-2);

                    var formatliTarih = gun + '-' + ay + '-' + yil;

                    return formatliTarih;
                }
            },
        }
    };
</script>
